const blogs = [
  {
    id: 1,
    desc : "Fashion That Turns Heads",
    title:"Discover the latest street-style outfits that blend comfort, confidence, and modern fashion trends.",
    imageUrl:
      "/assets/img/products/blog_1.png",
    createdAt : "July 15, 2024"  
  },
   {
    id: 2,
    desc : "Modern Looks for Every Occasion",
    title:"Explore stylish group fashion inspirations perfect for casual outings, parties, and everyday glam.",
    imageUrl:
      "/assets/img/products/blog_2.png",
        createdAt : "July 8, 2024"  
  
  },
{
    id: 3,
    desc : "Everyday Fashion with Confidence",
      title:"Upgrade your wardrobe with bold fashion pieces designed to make every moment effortlessly stylish.",
    imageUrl:
      "https://images.unsplash.com/photo-1713693211473-9a20e9b833ff?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTE1fHxzaG9wcGluZ3xlbnwwfHwwfHx8MA%3D%3D",
    createdAt:"July 1, 2024"  
  },

  
];
export {blogs}